import { render, staticRenderFns } from "./FieldManagerPanel.vue?vue&type=template&id=96dd2fa2&"
import script from "./FieldManagerPanel.vue?vue&type=script&lang=ts&"
export * from "./FieldManagerPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports